module.exports = __webpack_public_path__ + "img/order_takeaway.f77ec28a.svg";